import React from 'react';
import PropTypes from 'prop-types';
import {Wrapper} from '../../Wrapper';
import {Heading} from './Heading';
import {Content} from './Content';
import {Image} from '@learningblocks/shared-components/lib/Image';
import TOOLTIP_POINT from '@common/images/mc_tooltip_polygon.svg';

import './style.scss';

export function TooltipNormal(props) {
  const onMouseEnter = () => props.setHover(true);
  const onMouseLeave = () => props.setHover(false);

  return (
    <Wrapper
      className={`mc_tooltip  ${props.className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <Heading />
      <Content slotsFilled={props.slotsFilled} />
      <Image className='mc_tooltip_bottomImage' src={TOOLTIP_POINT} alt="" />
    </Wrapper>
  );
}

TooltipNormal.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * specifies the number of total slots filled in centrifuge
   */
  slotsFilled: PropTypes.number,
};

TooltipNormal.defaultProps = {
  className: '',
};
